import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import { addDocAction, listenCollection, updateDocAction } from '../../store/actions/firestoreActions'
import { ONE_ONE_QUESTION_COLLECTION, ONE_ONE_TOPIC_COLLECTION } from '../../_constants/globals'
import { useDispatch, useSelector } from 'react-redux'
import { pickBy } from 'lodash'
import useListener from '../../hooks/useListener'


const PROFILE_TYPES = [
  'CMI',
  'CAI',
  'MCI',
  'MFI',
  'FMI',
  'FAI',
  'AFI',
  'ACI',
  'CME',
  'CAE',
  'MCE',
  'MFE',
  'FME',
  'FAE',
  'AFE',
  'ACE',
]

export const ModalEditQuestion = ({ question, setEditQuestion }) => {
  
  useListener(() => listenCollection({ collection: ONE_ONE_TOPIC_COLLECTION }))
  const topics = useSelector(state => state.firestore.oneOneTopics)
  const dispatch = useDispatch()
  
  const [order, setOrder] = useState(0)
  const [topicId, setTopicId] = useState('')
  const [onlyApplyForProfile, setOnlyApplyForProfile] = useState('')
  const [frMan, setFrMan] = useState('')
  const [frWoman, setFrWoman] = useState('')
  const [enMan, setEnMan] = useState('')
  const [enWoman, setEnWoman] = useState('')
  const [customTitle, setCustomTitle] = useState('')
  
  const customQuestionTopicId = useMemo(() => topics?.find(t => t.slug === 'custom-questions').id, [topics])
  
  // Load edit question properties
  useEffect(() => {
    if (Object.keys(question).length === 0) return
    setOrder(question.order)
    setTopicId(question.oneOneTopicRef.id)
    question.onlyApplyForProfiles && setOnlyApplyForProfile(question.onlyApplyForProfiles[0])
    setFrMan(question.title?.fr.man)
    setFrWoman(question.title?.fr.woman)
    setEnMan(question.title?.en.man)
    setEnWoman(question.title?.en.woman)
    setCustomTitle(question.customTitle)
  }, [question])
  console.log('question', question)
  console.log('topicId', topicId)
  
  const handleClose = () => setEditQuestion(null)
  
  const handleSubmit = async e => {
    e.preventDefault()
    const object = {
      order: Number(order),
      onlyApplyForProfiles: [ onlyApplyForProfile ],
      title: topicId !== customQuestionTopicId && { fr: { man: frMan, woman: frWoman }, en: { man: enMan, woman: enWoman } },
      customTitle,
      oneOneTopicRef: topicId && [ONE_ONE_TOPIC_COLLECTION, topicId],
    }
    return question.id
      ? dispatch(updateDocAction(ONE_ONE_QUESTION_COLLECTION, question?.id, pickBy(object))).then(handleClose)
      : dispatch(addDocAction(ONE_ONE_QUESTION_COLLECTION, object)).then(handleClose)
  }
  
  return (
    <Dialog open onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{question.id ? `Edit question ${question.id}` : 'Create question'}</DialogTitle>
        <DialogContent>
          <TextField
            label='Order'
            type='number'
            value={order}
            onChange={event => setOrder(event.target.value)}
            sx={{ my: 1 }}
          />
          {topics && <FormControl fullWidth sx={{ my: 1 }}>
            <InputLabel id='apply-for-topic-label'>Sujet</InputLabel>
            <Select
              id='apply-for-topic'
              label='Sujet'
              value={topicId}
              onChange={event => setTopicId(event.target.value)}
            >
              {topics.map(item => <MenuItem key={item.id} value={item.id}>{item.slug}</MenuItem>)}
            </Select>
          </FormControl>}
          {topicId === customQuestionTopicId
            ? <TextField
              id='customTitle'
              label='Question'
              value={customTitle}
              onChange={event => setCustomTitle(event.target.value)}
              fullWidth
              sx={{ my: 1 }}
            />
            : <>
              <FormControl fullWidth sx={{ my: 1 }}>
                <InputLabel id='apply-for-profile-label'>Apply for profile</InputLabel>
                <Select
                  id='apply-for-profile'
                  label='Apply for profile'
                  value={onlyApplyForProfile}
                  onChange={event => setOnlyApplyForProfile(event.target.value)}
                >
                  {PROFILE_TYPES.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                </Select>
              </FormControl>
              <TextField
                id='qFrMan'
                label='Question fr man'
                value={frMan}
                onChange={event => setFrMan(event.target.value)}
                fullWidth
                sx={{ my: 1 }}
              />
              <TextField
                id='qFrWoman'
                label='Question fr woman'
                value={frWoman}
                onChange={event => setFrWoman(event.target.value)}
                fullWidth
                sx={{ my: 1 }}
              />
              <TextField
                id='qEnMan'
                label='Question en man'
                value={enMan}
                onChange={event => setEnMan(event.target.value)}
                fullWidth
                sx={{ my: 1 }}
              />
              <TextField
                id='qEnWoman'
                label='Question en woman'
                value={enWoman}
                onChange={event => setEnWoman(event.target.value)}
                fullWidth
                sx={{ my: 1 }}
              />
            </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='secondary'>Cancel</Button>
          <Button type='submit' color='secondary'>Save</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

ModalEditQuestion.propTypes = {
  question: PropTypes.object,
  setEditQuestion: PropTypes.func.isRequired,
}

export default ModalEditQuestion
